<div class="level">
  <div class="filters level-left">

    <div class="filter-item">
      <label>Country</label>

      <div class="custom-select multiple"
           appClickOutside
           (clickOutside)="countryDropdownOpened = false"
           (click)="toggleCountryDropdown()">

        <div class="selected-values">
          <ng-container *ngIf="selectedCountries.length; else allCountries">

          <span
            class="country-chip"
            *ngFor="let iso of selectedCountries.slice(0, 2)">
            {{ getCountryLabel(iso) }}
          </span>

            <span
              class="country-more"
              *ngIf="selectedCountries.length > 2">
            +{{ selectedCountries.length - 2 }}
          </span>
            <button
              class="clear-selection"
              type="button"
              (click)="clearCountries($event)"
              aria-label="Clear selected countries">
              ×
            </button>


          </ng-container>

          <ng-template #allCountries>
          <span class="placeholder">
            All countries
          </span>
          </ng-template>
        </div>


        <div class="country-dropdown" *ngIf="countryDropdownOpened">

          <div
            class="country-group"
            *ngFor="let group of countryGroupOptions">

            <div
              class="group-label p-1"
              [ngClass]="{
                'has-background-warning-light': group.group === 'OECD',
                'has-background-success-light': group.group === 'EU',
                'has-background-link-light': group.group === 'other'
              }"
              (click)="toggleCountryGroup(group)">

              {{ group.label }}

            </div>

            <label
              class="option"
              *ngFor="let country of group.countries"
              (click)="$event.stopPropagation()">

              <input
                type="checkbox"
                [checked]="selectedCountries.includes(country.iso)"
                (change)="toggleCountry(country.iso, $event)">

              <span>{{ country.label }}</span>

            </label>

          </div>

        </div>

      </div>
    </div>

    <!-- Incentive type -->
    <div class="filter-item">
      <label>Type of incentive</label>

      <div class="custom-select">

        <select
          [(ngModel)]="selectedIncentiveType"
          (ngModelChange)="applyFilters()">

          <option *ngFor="let type of incentiveTypes">
            {{ type }}
          </option>

        </select>
      </div>
    </div>
  </div>
  <div class="level-right">
    <div class="level-item">
      <a
        class="button is-small is-link-light is-hidden-touch"
        *ngIf="aggregation?.csv"
        (click)="downloadDataset(aggregation)"
      >
        <span>Download dataset</span>
        <span class="icon is-small">
              <i class="fa-solid fa-file-download"></i>
            </span>
      </a>
      <a
        class="button is-small is-link-light is-hidden-desktop"
        *ngIf="aggregation?.csv"
        (click)="downloadDataset(aggregation)"
      >
          <span class="icon is-small">
            <i class="fa-solid fa-file-download"></i>
          </span>
      </a>
    </div>
  </div>
</div>

<div class="table-wrapper">

  <table>

    <colgroup>
      <col style="width: 15%">
      <col style="width: 15%">
      <col style="width: 15%">
      <col style="width: 15%">
      <col style="width: 15%">
      <col style="width: 25%">
    </colgroup>

    <thead>
    <tr>
      <th *ngFor="let column of aggregation['column-labels']">
        {{ column }}
      </th>
    </tr>
    </thead>


    <tbody>

    <tr *ngFor="let row of filteredRows" [ngClass]="{'is-disabled': row.isDisabled}">

      <td *ngFor="let column of aggregation['column-labels']">

        <ng-container *ngIf="column === 'Type of incentive'; else normalCell">

            <span
              class="incentive-badge"
              [class.income]="row.incentiveType === 'Income-based'"
              [class.expenditure]="row.incentiveType === 'Expenditure-based'">

              {{ getValue(row,column) }}

            </span>

        </ng-container>


        <ng-template #normalCell>
            <span
              class="cell-value"
              [class.is-clickable]="isClickableColumn(column)"
              (click)="onCellClick(row, column)"
            >
             {{ getValue(row, column) || '-' }}
           </span>
        </ng-template>

      </td>

    </tr>

    </tbody>

  </table>

</div>
